<template>
  <div class="page-up-bt-container" :class="[isShow ? 'show' : '']" @click="backToTop">
    <p>back top</p>
    <div class="line">
      <div
        class="line__inner"
        :style="{
          backgroundColor: lineColor
        }"
      ></div>
    </div>
  </div>
</template>

<script>
const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];
export default {
  name: 'c__up-bt',
  data() {
    return {
      isShow: false,
      isTriggerScroll: false,
    };
  },
  computed: {
    lineColor() {
      const temp = colors;
      const data = [];
      for (let i = 0; i < 2; i += 1) {
        const c = Math.floor(Math.random() * (temp.length - i));
        data.push(temp[c]);
        temp[c] = temp[temp.length - i - 1];
      }
      return data;
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      window.addEventListener('scroll', that.onScroll);
    });
  },
  methods: {
    onScroll() {
      this.isTriggerScroll = true;
      // eslint-disable-next-line max-len
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      this.isShow = scrollTop >= window.innerHeight * 4;
    },
    backToTop() {
      document.documentElement.scrollTop = 0;
      this.$emit('backTop');
    },
  },
};
</script>

<style></style>
